import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/primeng';
import { MainComponent } from './main.component';
import { RouterConst } from '../../globals/RoutersConst';
import { Globals } from '../../globals/Globals';
import { HttpService } from '../../services/http.service';
import { UserMenu } from './user-menu';

declare let jQuery: any;

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() reset: boolean;

  model: any[];

  layoutMenuScroller: HTMLDivElement;
  dashBoard: any;

  @ViewChild('layoutMenuScroller') layoutMenuScrollerViewChild: ElementRef;

  constructor(public app: MainComponent, private http: HttpService) {}

  ngOnInit() {
    this.dashBoard = RouterConst.DASHBOARD;
    this.http
      .get(Globals.SERVER_ADDR + '/userMenu')
      .subscribe((response: any) => {
        const userMenu = new UserMenu(response.payload);
        console.log(userMenu);
        this.model = [];
        if (userMenu.menu_item_dash.allowed) {
          this.model.push({ label: 'Dashboard', icon: 'dashboard', items: [] });
          if (userMenu.menu_item_dash_1.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Key User Metrics',
              icon: 'equalizer',
              routerLink: [{ outlets: { sub: [RouterConst.DASHBOARD] } }],
            });
          }
          if (userMenu.menu_item_dash_2.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Charts and Summary',
              icon: 'equalizer',
              routerLink: [{ outlets: { sub: [RouterConst.CHARTS] } }],
            });
          }
          if (userMenu.menu_item_dash_reporting.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Reporting',
              icon: 'library_books',
              items: [
                // { label: 'Session Detail Report', icon: 'library_books' },
                {
                  label: 'Session Summary Report',
                  icon: 'library_books',
                  routerLink: [
                    { outlets: { sub: [RouterConst.SESSION_SUMMARY] } },
                  ],
                },
                {
                  label: 'Not Logged In Users',
                  icon: 'people_outline',
                  routerLink: [
                    { outlets: { sub: [RouterConst.NOT_LOGGED_IN_USERS] } },
                  ],
                },
                {
                  label: 'Session Detail Report',
                  icon: 'library_books',
                  routerLink: [
                    { outlets: { sub: [RouterConst.SESSION_DETAIL_REPORT] } },
                  ],
                },
                {
                  label: 'SMS Accounting',
                  icon: 'account_box',
                  routerLink: [
                    { outlets: { sub: [RouterConst.SMS_ACCOUNTING] } },
                  ],
                },
                {
                  label: 'Opt In Users',
                  icon: 'library_books',
                  routerLink: [
                    { outlets: { sub: [RouterConst.OPT_IN_USERS] } },
                  ],
                },
                {
                  label: 'Sent Messages',
                  icon: 'account_box',
                  routerLink: [
                    { outlets: { sub: [RouterConst.SENT_MESSAGES] } },
                  ],
                }
              ],
            });
          }
        }
        if (userMenu.menu_item_wifi_usage.allowed) {
          this.model.push({
            label: 'Usage Statistics',
            icon: 'supervisor_account',
            items: [],
          });
          if (userMenu.menu_item_wifi_usage_session.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Sessions',
              icon: 'account_box',
              routerLink: [{ outlets: { sub: [RouterConst.SESSIONS] } }],
            });
          }
          if (userMenu.menu_item_wifi_usage_login_method.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Login Method',
              icon: 'account_box',
              routerLink: [{ outlets: { sub: [RouterConst.LOGIN_METHOD] } }],
            });
          }
          if (userMenu.menu_item_wifi_usage_data_stats.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Data',
              icon: 'account_box',
              routerLink: [{ outlets: { sub: [RouterConst.DATA] } }],
            });
          }
        }
        if (userMenu.menu_item_userinfo.allowed) {
          this.model.push({
            label: 'Users',
            icon: 'supervisor_account',
            routerLink: [{ outlets: { sub: [RouterConst.USERS] } }],
          });
        }
        if (userMenu.menu_item_sessions.allowed) {
          this.model.push({
            label: 'Sessions',
            icon: 'perm_scan_wifi',
            items: [],
          });
          if (userMenu.menu_item_sessions_active_sessions.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Active Sessions',
              icon: 'network_wifi',
              routerLink: [
                { outlets: { sub: [RouterConst.SESSIONS_ACTIVE_SESSIONS] } },
              ],
            });
          }
          if (userMenu.menu_item_sessions_sessions_stats.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Session Statistics',
              icon: 'library_books',
              routerLink: [
                { outlets: { sub: [RouterConst.SESSIONS_SESSION_STAT] } },
              ],
            });
          }
        }
        if (userMenu.menu_item_organization.allowed) {
          this.model.push({
            label: 'Organization',
            icon: 'business',
            items: [],
          });
          if (userMenu.menu_item_organization_locations.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Location Setup',
              icon: 'settings',
              routerLink: [{ outlets: { sub: [RouterConst.LOCATION_SETUP] } }],
            });
          }
          if (userMenu.menu_item_organization_regions.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Location Groups',
              icon: 'location_on',
              routerLink: [{ outlets: { sub: [RouterConst.LOCATION_GROUPS] } }],
            });
          }
          if (userMenu.menu_item_organization_location_groups.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Regions',
              icon: 'location_on',
              routerLink: [
                { outlets: { sub: [RouterConst.LOCATION_REGIONS] } },
              ],
            });
          }
          if (userMenu.menu_item_organization_security_groups.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Security Groups',
              icon: 'supervisor_account',
              routerLink: [
                { outlets: { sub: [RouterConst.ANALYTICS_GROUPS] } },
              ],
            });
          }
          if (userMenu.menu_item_organization_analytics_users.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Analytics Users',
              icon: 'supervisor_account',
              routerLink: [{ outlets: { sub: [RouterConst.ANALYTICS_USERS] } }],
            });
          }
          if (userMenu.menu_item_organization_login_history.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Login History',
              icon: 'supervisor_account',
              routerLink: [{ outlets: { sub: [RouterConst.LOGIN_HISTORY] } }],
            });
          }
          if (userMenu.menu_item_organization_change_log.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Change Log',
              icon: 'supervisor_account',
              routerLink: [{ outlets: { sub: [RouterConst.CHANGE_LOG] } }],
            });
          }
          if (userMenu.menu_item_organization_accounts.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Accounts',
              icon: 'account_box',
              items: [],
            });
            if (userMenu.menu_item_organization_accounts_email.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Email Accounts',
                icon: 'account_box',
                routerLink: [
                  { outlets: { sub: [RouterConst.ANALYTICS_EMAIL_ACCOUNTS] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_sms.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Sms Accounts',
                icon: 'account_box',
                routerLink: [
                  { outlets: { sub: [RouterConst.ANALYTICS_SMS_ACCOUNTS] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_facebook.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Facebook Accounts',
                icon: 'account_box',
                routerLink: [
                  {
                    outlets: { sub: [RouterConst.ANALYTICS_FACEBOOK_ACCOUNTS] },
                  },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_twitter.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Twitter Accounts',
                icon: 'account_box',
                routerLink: [
                  {
                    outlets: { sub: [RouterConst.ANALYTICS_TWITTER_ACCOUNTS] },
                  },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_google.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Google Accounts',
                icon: 'account_box',
                routerLink: [
                  { outlets: { sub: [RouterConst.ANALYTICS_GOOGLE_ACCOUNTS] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_paypal.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Paypal Accounts',
                icon: 'account_box',
                routerLink: [
                  { outlets: { sub: [RouterConst.ANALYTICS_PAYPAL_ACCOUNTS] } },
                ],
              });
            }
            if (
              userMenu.menu_item_organization_accounts_paypal_options.allowed
            ) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Paypal Options',
                icon: 'account_box',
                routerLink: [
                  { outlets: { sub: [RouterConst.ANALYTICS_PAYPAL_OPTIONS] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_vouchers.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Vouchers',
                icon: 'account_box',
                routerLink: [
                  { outlets: { sub: [RouterConst.ANALYTICS_VOUCHERS] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_mailchimp.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Mailchimp Accounts',
                icon: 'account_box',
                routerLink: [
                  { outlets: { sub: [RouterConst.ANALYTICS_MAILCHIMP_ACC] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_accounts_mailchimp.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Wired Messenger Accounts',
                icon: 'account_box',
                routerLink: [
                  {
                    outlets: {
                      sub: [RouterConst.ANALYTICS_WIRED_MESSENGER_ACC],
                    },
                  },
                ],
              });
            }
          }
          if (userMenu.menu_item_organization_cp.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Captive Portal',
              icon: 'chrome_reader_mode',
              items: [],
            });
            if (userMenu.menu_item_organization_cp_add_update.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Add/Update',
                icon: 'system_update_alt',
                routerLink: [{ outlets: { sub: [RouterConst.ADD_UPDATE] } }],
              });
            }
            if (userMenu.menu_item_organization_cp_lang_locales.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Language & Locales',
                icon: 'language',
                routerLink: [{ outlets: { sub: [RouterConst.LOCALES] } }],
              });
            }
            if (userMenu.menu_item_organization_cp_cp_builder.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'CP Designer',
                icon: 'build',
                routerLink: [{ outlets: { sub: [RouterConst.DESIGNER] } }],
              });
            }
            if (
              userMenu.menu_item_organization_cp_redirect_strategies.allowed
            ) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Redirect Strategies',
                icon: 'label',
                routerLink: [
                  { outlets: { sub: [RouterConst.REDIRECT_CHANGES] } },
                ],
              });
            }
            if (
              userMenu.menu_item_organization_cp_messaging_strategies.allowed
            ) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Messaging Strategies',
                icon: 'label',
                routerLink: [
                  { outlets: { sub: [RouterConst.MESSAGING_STRATEGIES] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_cp_dynamic_images.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Dynamic Images',
                icon: 'image',
                routerLink: [
                  { outlets: { sub: [RouterConst.DYNAMIC_IMAGES] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_cp_image_uploader.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Image Uploader',
                icon: 'image',
                routerLink: [
                  { outlets: { sub: [RouterConst.IMAGE_UPLOADER] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_cp_background_uploader.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Background Uploader',
                icon: 'image',
                routerLink: [
                  { outlets: { sub: [RouterConst.BACKGROUND_UPLOADER] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_cp_fonts_uploader.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Fonts Uploader',
                icon: 'image',
                routerLink: [
                  { outlets: { sub: [RouterConst.FONTS_UPLOADER] } },
                ],
              });
            }
            if (userMenu.menu_item_organization_cp_terms_builder.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Terms Builder',
                icon: 'image',
                routerLink: [
                  { outlets: { sub: [RouterConst.TERMS_BUILDER] } },
                ],
              });
            }
          }
          if (userMenu.menu_item_organization_vocabularies.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Vocabularies',
              icon: 'account_box',
              items: [],
            });
            if (userMenu.menu_item_organization_vocabularies_counties.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'Countries',
                icon: 'system_update_alt',
                routerLink: [{ outlets: { sub: [RouterConst.COUNTRIES] } }],
              });
            }
            if (userMenu.menu_item_organization_vocabularies_cp_codes.allowed) {
              this.model[this.model.length - 1].items[
                this.model[this.model.length - 1].items.length - 1
              ].items.push({
                label: 'CP Codes',
                icon: 'language',
                routerLink: [{ outlets: { sub: [RouterConst.CP_CODES] } }],
              });
            }
          }
        }
        if (userMenu.menu_item_admin.allowed) {
          this.model.push({
            label: 'Admin',
            icon: 'supervisor_account',
            items: [],
          });
          if (userMenu.menu_item_admin_clients.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Clients',
              icon: 'account_box',
              routerLink: [{ outlets: { sub: [RouterConst.ADMIN_CLIENTS] } }],
            });
          }
          if (userMenu.menu_item_admin_forget_user.allowed) {
            this.model[this.model.length - 1].items.push({
              label: 'Forget User',
              icon: 'supervisor_account',
              routerLink: [{ outlets: { sub: [RouterConst.FORGET_USER] } }],
            });
          }
        }
      });
    console.log(this.model);
    // this.model = [
    // {
    //     label: 'Users', icon: 'people',
    //     items: [
    //         { label: 'Unique Users', icon: 'account_box' },
    //         { label: 'Device Type', icon: 'devices' },
    //         { label: 'Operating System', icon: 'computer' },
    //         { label: 'Browser', icon: 'web_asset' },
    //         { label: 'Demographics', icon: 'people_outline' }
    //     ]
    // },

    // {
    //     label: 'Locations', icon: 'place',
    //     items: [
    //         { label: 'Location Report', icon: 'location_city' },
    //         { label: 'Zip Code HeatMap', icon: 'home' },
    //         { label: 'Store Heatmap', icon: 'store' },
    //         { label: 'User Activity & Dwell', icon: 'transfer_within_a_station' },
    //         { label: 'Walking Routes & POI', icon: 'directions_walk' },
    //         { label: 'Store Layout Manager', icon: 'playlist_add_check' }
    //     ]
    // },

    // old serenity menu

    // {
    //     label: 'OLD SERENITY - Dashboard', icon: 'key-user-metrics', routerLink: ['/']
    // },
    // {
    //     label: 'Menu Modes', icon: 'settings',
    //     items: [
    //         { label: 'Static Menu', icon: 'view_quilt', command: (event) => { this.app.layoutStatic = true; } },
    //         { label: 'Overlay Menu', icon: 'flip_to-front', command: (event) => { this.app.layoutStatic = false; } },
    //         { label: 'Light Menu', icon: 'label', command: (event) => { this.app.darkMenu = false; } },
    //         { label: 'Dark Menu', icon: 'label_outline', command: (event) => { this.app.darkMenu = true; } }
    //     ]
    // },
    // {
    //     label: 'Layout Palette', icon: 'palette',
    //     items: [
    //         {
    //             label: 'Flat', icon: 'format_paint',
    //             items: [
    //                 { label: 'Blue Grey - Green', icon: 'brush', command: (event) => { this.changeLayout('bluegrey'); } },
    //                 { label: 'Indigo - Pink', icon: 'brush', command: (event) => { this.changeLayout('indigo'); } },
    //                 { label: 'Pink - Amber', icon: 'brush', command: (event) => { this.changeLayout('pink'); } },
    //                 { label: 'Deep Purple - Orange', icon: 'brush', command: (event) => { this.changeLayout('deeppurple'); } },
    //                 { label: 'Blue - Amber', icon: 'brush', command: (event) => { this.changeLayout('blue'); } },
    //                 { label: 'Light Blue - Blue Grey', icon: 'brush', command: (event) => { this.changeLayout('lightblue'); } },
    //                 { label: 'Cyan - Amber', icon: 'brush', command: (event) => { this.changeLayout('cyan'); } },
    //                 { label: 'Teal - Red', icon: 'brush', command: (event) => { this.changeLayout('teal'); } },
    //                 { label: 'Green - Brown', icon: 'brush', command: (event) => { this.changeLayout('green'); } },
    //                 { label: 'Light Green - Purple', icon: 'brush', command: (event) => { this.changeLayout('lightgreen'); } },
    //                 { label: 'Lime - Blue Grey', icon: 'brush', command: (event) => { this.changeLayout('lime'); } },
    //                 { label: 'Yellow - Teal', icon: 'brush', command: (event) => { this.changeLayout('yellow'); } },
    //                 { label: 'Amber - Pink', icon: 'brush', command: (event) => { this.changeLayout('amber'); } },
    //                 { label: 'Orange - Indigo', icon: 'brush', command: (event) => { this.changeLayout('orange'); } },
    //                 { label: 'Deep Orange - Cyan', icon: 'brush', command: (event) => { this.changeLayout('deeporange'); } },
    //                 { label: 'Brown - Cyan', icon: 'brush', command: (event) => { this.changeLayout('brown'); } },
    //                 { label: 'Grey - Indigo', icon: 'brush', command: (event) => { this.changeLayout('grey'); } }
    //             ]
    //         },
    //         {
    //             label: 'Special', icon: 'format_paint',
    //             items: [
    //                 { label: 'Reflection', icon: 'brush', command: (event) => { this.changeLayout('reflection'); } },
    //                 { label: 'Moody', icon: 'brush', command: (event) => { this.changeLayout('moody'); } },
    //                 { label: 'Cityscape', icon: 'brush', command: (event) => { this.changeLayout('cityscape'); } },
    //                 { label: 'Cloudy', icon: 'brush', command: (event) => { this.changeLayout('cloudy'); } },
    //                 { label: 'Storm', icon: 'brush', command: (event) => { this.changeLayout('storm'); } },
    //                 { label: 'Palm', icon: 'brush', command: (event) => { this.changeLayout('palm'); } },
    //                 { label: 'Flatiron', icon: 'brush', command: (event) => { this.changeLayout('flatiron'); } }
    //             ]
    //         },
    //     ]
    // },
    // {
    //     label: 'Themes', icon: 'brush', badge: '5',
    //     items: [
    //         { label: 'Blue Grey - Green', icon: 'brush', command: (event) => { this.changeTheme('bluegrey'); } },
    //         { label: 'Indigo - Pink', icon: 'brush', command: (event) => { this.changeTheme('indigo'); } },
    //         { label: 'Pink - Amber', icon: 'brush', command: (event) => { this.changeTheme('pink'); } },
    //         { label: 'Purple - Pink', icon: 'brush', command: (event) => { this.changeTheme('purple'); } },
    //         { label: 'Deep Purple - Orange', icon: 'brush', command: (event) => { this.changeTheme('deeppurple'); } },
    //         { label: 'Blue - Amber', icon: 'brush', command: (event) => { this.changeTheme('blue'); } },
    //         { label: 'Light Blue - Blue Grey', icon: 'brush', command: (event) => { this.changeTheme('lightblue'); } },
    //         { label: 'Cyan - Amber', icon: 'brush', command: (event) => { this.changeTheme('cyan'); } },
    //         { label: 'Teal - Red', icon: 'brush', command: (event) => { this.changeTheme('teal'); } },
    //         { label: 'Green - Brown', icon: 'brush', command: (event) => { this.changeTheme('green'); } },
    //         { label: 'Light Green - Purple', icon: 'brush', command: (event) => { this.changeTheme('lightgreen'); } },
    //         { label: 'Lime - Blue Grey', icon: 'brush', command: (event) => { this.changeTheme('lime'); } },
    //         { label: 'Yellow - Teal', icon: 'brush', command: (event) => { this.changeTheme('yellow'); } },
    //         { label: 'Amber - Pink', icon: 'brush', command: (event) => { this.changeTheme('amber'); } },
    //         { label: 'Orange - Indigo', icon: 'brush', command: (event) => { this.changeTheme('orange'); } },
    //         { label: 'Deep Orange - Cyan', icon: 'brush', command: (event) => { this.changeTheme('deeporange'); } },
    //         { label: 'Brown - Cyan', icon: 'brush', command: (event) => { this.changeTheme('brown'); } },
    //         { label: 'Grey - Indigo', icon: 'brush', command: (event) => { this.changeTheme('grey'); } }
    //     ]
    // },
    // {
    //     label: 'Orientation', icon: 'format_align_right',
    //     items: [
    //         { label: 'LTR', icon: 'format_align_left', command: (event) => { this.app.isRTL = false; } },
    //         { label: 'RTL', icon: 'format_align_right', command: (event) => { this.app.isRTL = true; } }
    //     ]
    // },
    // {
    //     label: 'Components', icon: 'list', badge: '2', badgeStyleClass: 'orange-badge',
    //     items: [
    //         { label: 'Sample Page', icon: 'desktop_mac', routerLink: ['/sample'] },
    //         { label: 'Forms', icon: 'input', routerLink: ['/forms'] },
    //         { label: 'Data', icon: 'grid_on', routerLink: ['/data'] },
    //         { label: 'Panels', icon: 'content_paste', routerLink: ['/panels'] },
    //         { label: 'Overlays', icon: 'content_copy', routerLink: ['/overlays'] },
    //         { label: 'Menus', icon: 'menu', routerLink: ['/menus'] },
    //         { label: 'Messages', icon: 'message', routerLink: ['/messages'] },
    //         { label: 'Charts', icon: 'insert_chart', routerLink: ['/charts'] },
    //         { label: 'File', icon: 'attach_file', routerLink: ['/file'] },
    //         { label: 'Misc', icon: 'toys', routerLink: ['/misc'] }
    //     ]
    // },
    // {
    //     label: 'Template Pages', icon: 'get_app',
    //     items: [
    //         { label: 'Empty Page', icon: 'hourglass_empty', routerLink: ['/empty'] },
    //         { label: 'Home Page', icon: 'home', url: 'assets/pages/home.html', target: '_blank' },
    //         { label: 'Landing Page', icon: 'flight_land', url: 'assets/pages/landing.html', target: '_blank' },
    //         { label: 'Login Page', icon: 'verified_user', url: 'assets/pages/login.html', target: '_blank' },
    //         { label: 'Error Page', icon: 'error', url: 'assets/pages/error.html', target: '_blank' },
    //         { label: '404 Page', icon: 'error_outline', url: 'assets/pages/404.html', target: '_blank' },
    //         { label: 'Access Denied Page', icon: 'security', url: 'assets/pages/access.html', target: '_blank' }
    //     ]
    // },
    // {
    //     label: 'Menu Hierarchy', icon: 'menu',
    //     items: [
    //         {
    //             label: 'Submenu 1', icon: 'subject',
    //             items: [
    //                 {
    //                     label: 'Submenu 1.1', icon: 'subject',
    //                     items: [
    //                         { label: 'Submenu 1.1.1', icon: 'subject' },
    //                         { label: 'Submenu 1.1.2', icon: 'subject' },
    //                         { label: 'Submenu 1.1.3', icon: 'subject' },
    //                     ]
    //                 },
    //                 {
    //                     label: 'Submenu 1.2', icon: 'subject',
    //                     items: [
    //                         { label: 'Submenu 1.2.1', icon: 'subject' },
    //                         { label: 'Submenu 1.2.2', icon: 'subject' }
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: 'Submenu 2', icon: 'subject',
    //             items: [
    //                 {
    //                     label: 'Submenu 2.1', icon: 'subject',
    //                     items: [
    //                         { label: 'Submenu 2.1.1', icon: 'subject' },
    //                         { label: 'Submenu 2.1.2', icon: 'subject' },
    //                         { label: 'Submenu 2.1.3', icon: 'subject' }
    //                     ]
    //                 },
    //                 {
    //                     label: 'Submenu 2.2', icon: 'subject',
    //                     items: [
    //                         { label: 'Submenu 2.2.1', icon: 'subject' },
    //                         { label: 'Submenu 2.2.2', icon: 'subject' }
    //                     ]
    //                 },
    //             ]
    //         }
    //     ]
    // },
    // { label: 'Utils', icon: 'build', routerLink: ['/utils'] },
    // { label: 'Documentation', icon: 'find_in_page', routerLink: ['/documentation'] },
    // { label: 'Buy Now', icon: 'credit_card', url: 'https://www.primefaces.org/store' }

    // ];
  }

  ngAfterViewInit() {
    this.layoutMenuScroller = <HTMLDivElement>this.layoutMenuScrollerViewChild
      .nativeElement;

    setTimeout(() => {
      jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
    }, 10);
  }

  changeTheme(theme) {
    const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById(
      'theme-css',
    );
    themeLink.href = 'assets/theme/theme-' + theme + '.css';
  }

  changeLayout(theme) {
    const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById(
      'layout-css',
    );
    layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
  }

  updateNanoScroll() {
    setTimeout(() => {
      jQuery(this.layoutMenuScroller).nanoScroller();
    }, 500);
  }

  ngOnDestroy() {
    jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
  }
}

@Component({
  /* tslint:disable:component-selector */
  selector: '[app-submenu]',
  /* tslint:enable:component-selector */
  template: `
    <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
      <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass">
        <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" *ngIf="!child.routerLink"
           [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
           (mouseenter)="hover=true" (mouseleave)="hover=false" class="ripplelink">
          <i class="material-icons">{{child.icon}}</i>
          <span class="menuitem-text">{{child.label}}</span>
          <i class="material-icons layout-submenu-toggler" *ngIf="child.items">keyboard_arrow_down</i>
          <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
        </a>

        <a (click)="itemClick($event,child,i)" *ngIf="child.routerLink"
           [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
           [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null"
           [attr.target]="child.target"
           (mouseenter)="hover=true" (mouseleave)="hover=false" class="ripplelink">
          <i class="material-icons">{{child.icon}}</i>
          <span class="menuitem-text">{{child.label}}</span>
          <i class="material-icons layout-submenu-toggler" *ngIf="child.items">>keyboard_arrow_down</i>
          <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
        </a>
        <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset"
            [@children]="isActive(i) ? 'visible' : 'hidden'"></ul>
      </li>
    </ng-template>
  `,
  animations: [
    trigger('children', [
      state(
        'visible',
        style({
          height: '*',
        }),
      ),
      state(
        'hidden',
        style({
          height: '0px',
        }),
      ),
      transition(
        'visible => hidden',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'),
      ),
      transition(
        'hidden => visible',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'),
      ),
    ]),
  ],
})
export class AppSubMenuComponent {
  @Input() item: MenuItem;

  @Input() root: boolean;

  @Input() visible: boolean;
  activeIndex: number;
  hover: boolean;

  constructor(
    public app: MainComponent,
    public router: Router,
    public location: Location,
  ) {}

  _reset: boolean;

  @Input()
  get reset(): boolean {
    return this._reset;
  }

  set reset(val: boolean) {
    this._reset = val;
  }

  itemClick(event: Event, item: MenuItem, index: number) {
    // avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    // activate current item and deactivate active sibling if any
    if (item.routerLink || item.items || item.command || item.url) {
      this.activeIndex = this.activeIndex === index ? null : index;
    }

    // execute command
    if (item.command) {
      item.command({ originalEvent: event, item: item });
    }

    // prevent hash change
    if (item.items || (!item.url && !item.routerLink)) {
      event.preventDefault();
    }

    // hide menu
    if (!item.items) {
      if (this.app.isMobile()) {
        this.app.sidebarActive = false;
        this.app.mobileMenuActive = false;
      }
    }
  }

  isActive(index: number): boolean {
    return this.activeIndex === index;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/main/app.menu.component.ts